/* global attachEvent */
attachEvent('.participant-inner:not(.disabled)', 'click', (participantInner) => {
  const participant = participantInner.target.closest('.participant');
  const parent = participant.closest('.publications-item__right');

  const toggleParticipantClass = (isTrue) => {
    participant.classList.toggle('is-added', isTrue);
  }

  const addHere = (parentItem, item) => {
    parent.querySelector(parentItem).appendChild(item);
  }

  if (participant.closest('.participants__box__right-people') || participant.closest('.participants__box__right__other-list')) {
    toggleParticipantClass(true);
    addHere('.participants__box__left', participant);
  } else if (participant.classList.contains('participant--other')) {
    toggleParticipantClass(false);
    addHere('.participants__box__right__other-list', participant);
  } else {
    toggleParticipantClass(false);
    addHere('.participants__box__right-people', participant);
  }

  // eslint-disable-next-line no-new
  new Sortable(participantInner.target.closest('.participants__box').querySelector('.participants__box__left'), {
    handle: '.participant',
    animation: 200,
    delay: 0,
    delayOnTouchOnly: true,
    ghostClass: 'sortable-ghost',
  });
});

attachEvent('.participants-search', 'keyup', (search) => {
  const itemsPeople = search.target.closest('.participants__box__right');
  itemsPeople.querySelectorAll('.participant-inner span').forEach((item) => {
    const itemParticipant = item;
    itemParticipant.closest('.participant').style.display =
      itemParticipant.innerText.toLowerCase().indexOf(search.target.value.toLowerCase()) === -1 ? 'none' : 'block';
  });
});

const changeValueForParticipant = (item) => {
  const selected = item.target.closest('.publications-item');
  const isAdded = selected.querySelectorAll('.participants__box__left .is-added span');
  const values = [];
  isAdded.forEach((itemValue) => {
    values.push(itemValue.innerText);
  });
  selected.querySelector('.public-participant').value = String(values);
}

attachEvent('.participant-inner', 'click', (item) => {
  changeValueForParticipant(item);
});

attachEvent('.publications-item__arrange-delete', 'click', (item) => {
  const selected = item.target.closest('.publications-item');
  const isAdded = selected.querySelector('[name="publication-id[]"]');
  if (isAdded.value) {
    const oldValues = document.querySelector('.deleted-items');
    oldValues.value = `${oldValues.value}|${isAdded.value}`;
  }
});

attachEvent('.intra-profile-edit span.btn--default', 'click', () => {
  document.querySelector('.intra-profile-edit').submit();
});

// **************************************************

attachEvent('.publications-item__arrange-delete', 'click', (deleteBtn) => {
  const parent = deleteBtn.target.closest('.publications-item');
  slideUp(parent, 300, 'none');
  setTimeout(() => {
    parent.remove();
  }, 300);
});

// **************************************************

attachEvent('.add-publication', 'click', (addBtn) => {
  const parent = addBtn.target.closest('.intra-profile-edit__item');
  const wrapper = parent.querySelector('.publications-items');
  const publication = parent.querySelector('.publications-item.default');
  const clone = publication.cloneNode(true);
  clone.classList.remove('default');
  wrapper.append(clone);
  slideDown(clone, 300, 'grid');

  flatpickr('.datepicker__placeholder-input', {
    disableMobile: 'true',
  });
});

// **************************************************

const publicationsList = document.querySelector('.publications-items');

if (publicationsList) {
  // eslint-disable-next-line no-new
  new Sortable(publicationsList, {
    handle: '.publications-item__arrange-btn',
    animation: 200,
    delay: 0,
    delayOnTouchOnly: true,
    ghostClass: 'sortable-ghost',
  });
  publicationsList.querySelectorAll('.public-participant').forEach((item) => {
    const { value } = item;
    if (value) {
      const rightBox = item.closest('.publications-item').querySelectorAll('.participants__box__right-people span');
      const addedParticipants = value.split(',');
      rightBox.forEach((rText) => {
        if (addedParticipants.includes(rText.innerHTML)) {
          rText.closest('.participant').remove();
        }
      });
      let html = '';
      addedParticipants.forEach((user) => {
        // eslint-disable-next-line no-param-reassign
        html += `<div class="participant is-added">
														<div class="participant-inner">	
<i data-component="at-icon" class="icon : icon-close"></i>
															<span>${user}</span>
														</div>
													</div>`
      });
      // eslint-disable-next-line no-param-reassign
      item.closest('.publications-item').querySelector('.participants__box__left').innerHTML = html;
    }
    // eslint-disable-next-line no-new
    new Sortable(item.closest('.participants__box').querySelector('.participants__box__left'), {
      handle: '.participant',
      animation: 200,
      delay: 0,
      delayOnTouchOnly: true,
      ghostClass: 'sortable-ghost',
      onEnd (evt) {
        changeValueForParticipant(evt);
      }
    });
  });
}
// ************************************************** Intra upload image preview
const fileUploaderNew = document.querySelector('#file');

const getImgData = () => {
  const files = fileUploaderNew.files[0];
  if (files) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(files);
    fileReader.addEventListener('load', (e) => {
      document.querySelector('.mod-file-upload__icon').innerHTML = `<img src="${e.currentTarget.result}"  alt="user-avatar"/>`;
    });
  }
};

if (fileUploaderNew) {
  fileUploaderNew.addEventListener('change', () => {
    getImgData();
  });
}

// **************************************************
// Add other participants
// **************************************************
const addParticipant = (input) => {
  const inputValue = input.value.trim();

  if (inputValue !== '') {
    const htmlString = `
      <div class="participant-inner">
        <i data-component="at-icon" class="icon : icon-close"></i>
        <span>${inputValue}</span>
      </div>
    `;

    const list = input.closest('.participants__box__right__other-people').querySelector('.participants__box__right__other-list');
    const newDiv = document.createElement('div');
    newDiv.classList.add('participant', 'participant--other');
    newDiv.innerHTML = htmlString;
    list.appendChild(newDiv);

    // eslint-disable-next-line no-param-reassign
    input.value = '';
  }
}

attachEvent('.participants__add-other', 'keydown', (event) => {
  if (event.key === "Enter") {
    addParticipant(event.target);
  }
});

attachEvent('.participants__add-other-btn', 'click', (event) => {
  const addOtherBtn = event.target.closest('.participants__box__right__other-people').querySelector('.participants__add-other');
  addParticipant(addOtherBtn);
});
